export interface IDevice {
  id: string;
  label: string;
  acceptedExtensions: string;
}

const COMMON_DEVICES: IDevice[] = [
  // Deep Capsule devices
  { id: 'mirocam', label: 'MiroCam', acceptedExtensions: '.avi' },
  { id: 'olympus', label: 'Olympus EC-10', acceptedExtensions: '.wmv,.mp4' },
  // Also IBD Smart
  { id: 'omom', label: 'OMOM HD', acceptedExtensions: '.avi' },
  { id: 'sb2', label: 'PillCam SB2', acceptedExtensions: '.mpg,.avi' },
  // Also IBD Smart
  { id: 'sb3', label: 'PillCam SB3', acceptedExtensions: '.gvf,.mpg' },
  // Smart Cholangio devices
  {
    id: 'spyglass',
    label: 'SpyGlass DS',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'spyglass2',
    label: 'SpyGlass DS2',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'eyemax',
    label: 'EyeMax',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'seegen',
    label: 'Seegen™ Choledochoscope',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  // Smart Cyst and Smart Pancreas ultrasound processors
  {
    id: 'eu-me2',
    label: 'Olympus EU-ME2',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'eu-me3',
    label: 'Olympus EU-ME3',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'fujifilm-su-1',
    label: 'Fujifilm SU-1 Platinum',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'fujifilm-arietta-850ff',
    label: 'Fujifilm ARIETTA 850 FF Endo',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'hitachi-arietta-850',
    label: 'Hitachi ARIETTA 850',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'fujifilm-arietta-750',
    label: 'Fujifilm ARIETTA 750',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'aloka-f75',
    label: 'Aloka ProSound F75',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'aloka-alpha5',
    label: 'Aloka ProSound Alpha 5',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  // Anoscopy Genius devices
  {
    id: 'thd_proctostation',
    label: 'THD® ProctoStation',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'kolplast_klp_210',
    label: 'Kolplast KLP 210 LED',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'zeiss_ksk_150',
    label: 'Zeiss KSK 150-FC',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'seiler_955',
    label: 'Seiler 955 5-Step Colposcope',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  {
    id: 'newton_clp',
    label: 'Newton CLP Config 3',
    acceptedExtensions: '.png,.jpeg,.jpg',
  },
  // IBD Smart devices
  {
    id: 'pillcam-colon-2',
    label: 'PillCam COLON 2 System',
    acceptedExtensions: '.gvf,.mpg',
  },
  {
    id: 'pillcam-crohn',
    label: "PillCam Crohn's Capsule",
    acceptedExtensions: '.gvf,.mpg',
  },
  {
    id: 'omom-cc-colon',
    label: 'OMOM CC Colon',
    acceptedExtensions: '.avi',
  },
];

export const EU_DEVICES = [
  ...COMMON_DEVICES,
  // Deep Capsule device
  {
    id: 'sb1',
    label: 'PillCam SB1',
    acceptedExtensions: '.mpg,.avi',
  },
];

export const US_DEVICES = [
  ...COMMON_DEVICES,
  // Deep Capsule device
  {
    id: 'sb1',
    label: 'PillCam M2A (SB1)',
    acceptedExtensions: '.mpg,.avi',
  },
];

/**
 * The order of devices in the lists below determines the display order in the UI.
 */

export const US_DEEP_CAPSULE_DEVICES = ['olympus', 'sb1', 'sb2', 'sb3'];
export const EU_DEEP_CAPSULE_DEVICES = ['olympus', 'omom', 'sb1', 'sb2', 'sb3'];

export const SMART_CHOLANGIO_DEVICES = [
  'spyglass',
  'spyglass2',
  'eyemax',
  'seegen',
];

export const SMART_CYST_ULTRASOUND_DEVICES = [
  'eu-me2',
  'eu-me3',
  'fujifilm-su-1',
  'fujifilm-arietta-850ff',
  'hitachi-arietta-850',
  'fujifilm-arietta-750',
  'aloka-f75',
  'aloka-alpha5',
];

export const SMART_PANCREAS_ULTRASOUND_DEVICES = SMART_CYST_ULTRASOUND_DEVICES;

export const ANOSCOPY_GENIUS_DEVICES = [
  'thd_proctostation',
  'kolplast_klp_210',
  'zeiss_ksk_150',
  'seiler_955',
  'newton_clp',
];

export const EU_IBD_SMART_DEVICES = [
  'sb3',
  'pillcam-colon-2',
  'pillcam-crohn',
  'olympus',
  'omom',
  'omom-cc-colon',
];

export const US_IBD_SMART_DEVICES = [
  'sb3',
  'pillcam-colon-2',
  'pillcam-crohn',
  'olympus',
];
